// extracted by mini-css-extract-plugin
module.exports =  {"mapArea":"jut__MapArea_DEPRECATED__mapArea"};